import { getNamedFormat, filterProps } from '../utils';
import { FormatError } from 'intl-messageformat';
import { ReactIntlError } from '../error';
var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];

function getFormatter(_ref, getRelativeTimeFormat) {
  var locale = _ref.locale,
      formats = _ref.formats,
      onError = _ref.onError;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var format = options.format;
  var defaults = !!format && getNamedFormat(formats, 'relative', format, onError) || {};
  var filteredOptions = filterProps(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
  return getRelativeTimeFormat(locale, filteredOptions);
}

export function formatRelativeTime(config, getRelativeTimeFormat, value, unit) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  if (!unit) {
    unit = 'second';
  }

  var RelativeTimeFormat = Intl.RelativeTimeFormat;

  if (!RelativeTimeFormat) {
    config.onError(new FormatError("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", "MISSING_INTL_API"
    /* MISSING_INTL_API */
    ));
  }

  try {
    return getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
  } catch (e) {
    config.onError(new ReactIntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting relative time.', e));
  }

  return String(value);
}